import { FilterAlt, FilterAltOff } from '@mui/icons-material';
import { ToggleButton, Tooltip } from '@mui/material';
import { GridApi } from 'ag-grid-community';
import React, { Dispatch, SetStateAction } from 'react';
import { recordAction } from 'src/infrastructure/telemetry';

interface EnableAdvancedFiltersButtonProps {
    gridApi: GridApi | null;
    clearSettings: () => void;
    enableAdvancedFiltering: boolean;
    setEnableAdvancedFiltering: Dispatch<SetStateAction<boolean>>;
}

const EnableAdvancedFiltersButton: React.FC<EnableAdvancedFiltersButtonProps> = ({
    gridApi,
    clearSettings,
    enableAdvancedFiltering,
    setEnableAdvancedFiltering,
}) => {
    const toggleAdvancedFiltering = () => {
        if (gridApi) {
            setEnableAdvancedFiltering(!enableAdvancedFiltering);
            gridApi?.setGridOption('enableAdvancedFilter', !enableAdvancedFiltering);
            gridApi?.refreshHeader();
            clearSettings();
            recordAction('advanced-filters', {
                enabled: !enableAdvancedFiltering,
            });
        }
    };

    return (
        <Tooltip title={enableAdvancedFiltering ? 'Disable advanced filters' : 'Enable advanced filters'}>
            <span>
                <ToggleButton
                    className="enable-advanced-filters"
                    value="enable-advanced-filters"
                    selected={enableAdvancedFiltering}
                    color="primary"
                    onClick={toggleAdvancedFiltering}
                    disabled={!gridApi}
                >
                    {enableAdvancedFiltering ? <FilterAlt /> : <FilterAltOff />}
                </ToggleButton>
            </span>
        </Tooltip>
    );
};

export default EnableAdvancedFiltersButton;
